var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3496 2.04999H6.14961C5.02211 2.04999 4.10986 2.97249 4.10986 4.09999L4.09961 20.5C4.09961 21.6275 5.01186 22.55 6.13936 22.55H18.4496C19.5771 22.55 20.4996 21.6275 20.4996 20.5V8.19999L14.3496 2.04999ZM18.4496 20.5H6.14961V4.09999H13.3246V9.22499H18.4496V20.5ZM8.19961 15.3852L9.64486 16.8305L11.2746 15.211V19.475H13.3246V15.211L14.9544 16.8407L16.3996 15.3852L12.3099 11.275L8.19961 15.3852Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedUploadIcon);
export default __webpack_public_path__ + "static/media/failed-upload-icon.18126e37dcb1d039e5e9727f6b57f92c.svg";
export { ForwardRef as ReactComponent };